import React, {FC, useState} from "react";
import {Dropdown, DropdownButton, FormLabel} from "react-bootstrap";
import {EditableText} from "../Shared/EditableWidgets";

export interface Role {
  title: string,
  value: string
}

interface DropdownRoleProps {
  role: Role,
  setRole: (role: Role) => void
}

export const DropdownRoles = [
  {title: "Choose one of the following...", value: ""},
  {title: "Enterprise", value: "enterprise"},
  {title: "Gamer", value: "gamer"},
  {title: "Sales", value: "sales"},
  {title: "Marketing", value: "marketing"},
  {title: "Engineer", value: "engineer"},
  {title: "Product manager", value: "product manager"},
  {title: "HR", value: "hr"},
  {title: "Design", value: "designer"},
  {title: "Investor", value: "investor"},
  {title: "Executive", value: "executive"},
  {title: "Student", value: "student"},
  {title: "Teacher", value: "teacher"},
  {title: "NFT Fan", value: "nft fan"},
  {title: "Other", value: ""}, // todo error when not filled out
]

const DropdownRole: FC<DropdownRoleProps> = ({role, setRole}) => {
  const [value, setValue] = useState("");
  const [message, setMessage] = useState('');

  const items = DropdownRoles.map((role: Role, index) => {
      return (
        <Dropdown.Item key={`dropdown-device-${index}`} onClick={() => {
          if (role.title === "Other") {
            setRoleAndMessage({title: role.title, value});
          } else {
            setRoleAndMessage(role);
          }
        }}>
          {role.title}
        </Dropdown.Item>
      );
    }
  );

  function setRoleAndMessage(role: Role) {
    if (role.value === "gamer") {
      setMessage("You can fly, explore, socialize, build Metaverses in a few clicks, no design/code required, and have endless fun over Villa. In app games launching from time to time");
    } else if (role.value === "nft fan") {
      setMessage("Fantastic! You're going to love spawning your NFTs to 3D galleries, exhibits and in meetings, and coming soon over virtual Metaverse land. NFT projects email info@villa.rocks");
    } else {
      setMessage('Fantastic! Get ready for immersive Metaverse meetings with colleagues & clients that are gazillions more fun, creative, and productive than Zoom or IRL');
    }
    setRole(role);
  }

  function setValueAndRole(value: string) {
    setValue(value);
    if (role.title === "Other") {
      setRole({title: role.title, value});
    } else {
      setRoleAndMessage(role);
    }
  }

  const valueEdit = (role.title == "Other") ?
    <div className="col-8">
      <EditableText
        value={value}
        maxLength={40}
        onChange={(event: any) => setValueAndRole(event.target.value)}
        isEditable={true}
        isEditing={true}
        setIsEditing={() => {
        }}
        placeholder="Role or title in company or Metaverse"
        ariaLabel="Role"
      />
    </div>
    : null;

  return (
    <>
      <div className="row">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6">
          <h5><span className="orange">{message}</span></h5>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6 pb-1">
          <FormLabel className="mb-0">My role is *</FormLabel>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
      <div className="row py-0">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col">
              <Dropdown onClick={(e: any) => e.stopPropagation()}>
                <DropdownButton key="dropdown-button" menuAlign="left" title={role.title}>
                  {items}
                </DropdownButton>
              </Dropdown>
            </div>
            {valueEdit}
          </div>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>

    </>
  );
}

export default DropdownRole;
